export const toastifyIcons = () => {
  const InfoIcon = (
    <svg width={22} height={22} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 1.833c-5.054 0-9.166 4.112-9.166 9.167s4.112 9.167 9.167 9.167c5.054 0 9.166-4.113 9.166-9.167 0-5.055-4.112-9.167-9.166-9.167Zm0 16.5c-4.043 0-7.333-3.29-7.333-7.333s3.29-7.333 7.334-7.333c4.043 0 7.333 3.29 7.333 7.333s-3.29 7.333-7.333 7.333Z"
        fill="#027AFF"
      />
      <path
        d="M10.084 10.083h1.833v5.5h-1.833v-5.5Zm0-3.666h1.833V8.25h-1.833V6.417Z"
        fill="#027AFF"
      />
    </svg>
  );

  const SuccessIcon = (
    <svg width={22} height={22} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.166 14.287 6.148 11.27l-1.296 1.296 4.314 4.315 8.898-8.899-1.296-1.296-7.602 7.602Z"
        fill="#00BC82"
      />
    </svg>
  );

  const WarningIcon = (
    <svg width={22} height={22} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.085 9.167h1.833v4.583h-1.833V9.167Zm-.001 5.5h1.833V16.5h-1.833v-1.833Z"
        fill="#F9A000"
      />
      <path
        d="M12.62 3.85c-.318-.6-.94-.973-1.62-.973a1.83 1.83 0 0 0-1.62.974L2.652 16.559a1.82 1.82 0 0 0 .05 1.804 1.818 1.818 0 0 0 1.57.887h13.454a1.82 1.82 0 0 0 1.572-.887 1.825 1.825 0 0 0 .049-1.804L12.621 3.85ZM4.272 17.417 11 4.709l6.732 12.708H4.272Z"
        fill="#F9A000"
      />
    </svg>
  );

  const ErrorIcon = (
    <svg width={22} height={22} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.958 1.833c-5.031 0-9.124 4.113-9.124 9.167 0 5.055 4.112 9.167 9.167 9.167 5.054 0 9.166-4.113 9.166-9.167 0-5.054-4.131-9.167-9.21-9.167Zm.043 16.5c-4.044 0-7.334-3.29-7.334-7.333s3.27-7.333 7.29-7.333c4.069 0 7.377 3.29 7.377 7.333s-3.29 7.333-7.333 7.333Z"
        fill="#EF6355"
      />
      <path
        d="M10.084 6.417h1.833v6.416h-1.833V6.417Zm0 7.333h1.833v1.833h-1.833V13.75Z"
        fill="#EF6355"
      />
    </svg>
  );

  return { InfoIcon, SuccessIcon, WarningIcon, ErrorIcon };
};
